import { useEffect, useState } from "react";

/**
 * Owner 2026-10-23: every screen that sends a code offers a resend, after a
 * wait, with a countdown. The wait is per screen visit; the services keep
 * their own rate limits.
 */
export const RESEND_AFTER_SECONDS = 60;

/** Seconds left as m:ss. */
export function countdown(seconds: number): string {
  const s = Math.max(0, Math.ceil(seconds));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}

/** A label with the wait appended while it runs: "Resend SMS (0:45)". */
export function waitLabel(label: string, left: number): string {
  return left > 0 ? `${label} (${countdown(left)})` : label;
}

/** Seconds until a resend is allowed, and start() to begin a new wait. */
export function useResendWait(seconds = RESEND_AFTER_SECONDS): { left: number; start: () => void } {
  const [until, setUntil] = useState(0);
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (until <= now) return;
    const id = window.setTimeout(() => setNow(Date.now()), 1000);
    return () => window.clearTimeout(id);
  }, [until, now]);
  const start = () => {
    const t = Date.now();
    setNow(t);
    setUntil(t + seconds * 1000);
  };
  return { left: Math.max(0, Math.ceil((until - now) / 1000)), start };
}
